const resumeListeners = new Set();
let registered = false;
let lastMouseMoveAt = 0;
let store = null;

export function initActivityService(vuexStore) {
    store = vuexStore;
}

function getStore() {
    return store;
}

function isIdleNow() {
    const { lastActivityAt, idleThresholdMs } = getStore().state.activityStore;
    return Date.now() - lastActivityAt >= idleThresholdMs;
}

export function touchUserActivity() {
    const vuexStore = getStore();
    const wasIdle = isIdleNow();
    vuexStore.commit("activityStore/touchActivity");

    if (wasIdle) {
        resumeListeners.forEach((callback) => {
            try {
                callback();
            } catch (e) {
                console.log(e);
            }
        });
    }
}

function onMouseMove() {
    const now = Date.now();
    if (now - lastMouseMoveAt < 30000) {
        return;
    }

    lastMouseMoveAt = now;
    touchUserActivity();
}

export function registerActivityTracking() {
    if (registered) {
        return;
    }

    registered = true;
    getStore().commit("activityStore/setListenersRegistered", true);

    ["click", "contextmenu", "keydown", "scroll", "touchstart"].forEach((eventName) => {
        document.addEventListener(eventName, touchUserActivity, { passive: true });
    });

    document.addEventListener("mousemove", onMouseMove, { passive: true });
    document.addEventListener("visibilitychange", () => {
        if (!document.hidden) {
            touchUserActivity();
        }
    });
    window.addEventListener("focus", touchUserActivity);
}

export function onActivityResume(callback) {
    resumeListeners.add(callback);
    return () => resumeListeners.delete(callback);
}

export function isUserIdle() {
    return isIdleNow();
}
